import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import Localization from "../../localization";
import Button from "../button";
import IconClose from "../icons/close";
import Gallery from "../gallery";
import Image from "../image";

import { changeMobileFloor } from "../../redux/actions/options";
import { getSpaceDetails } from "../../redux/selectors/space";

class MobileFloor extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._onClose = this._onClose.bind(this);
    }

    _onClose() {
        this.props.changeMobileFloor(false);
    }

    render() {
        const { visible, locale, space } = this.props;

        let textColor = "text-blue";
        let buttonBackgroundColor = "bg-blue";
        let buttonTextColor = "text-white";
        let borderColor = "border-blue";

        if (!space || !visible) return null;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        let floorText = Localization[locale].spaces_booking.floor0;
        let imageSrc = "/img/piso-0.png";
        let titleName = space.name;
        let titleFloor =
            Localization[locale].spaces_booking.step_1_studio_type_1;

        if (space.id === 1) {
            floorText = Localization[locale].spaces_booking.floor0;
            imageSrc = "/img/piso-0.png";

            titleName = Localization[locale].spaces_booking.step_1_studio_1;
            titleFloor =
                Localization[locale].spaces_booking.step_1_studio_type_1;
        } else if (space.id === 2) {
            floorText = Localization[locale].spaces_booking.floor0;
            imageSrc = "/img/piso-0.png";

            titleName = Localization[locale].spaces_booking.step_1_studio_2;
            titleFloor =
                Localization[locale].spaces_booking.step_1_studio_type_1;
        } else if (space.id === 3) {
            floorText = Localization[locale].spaces_booking.floor1;
            imageSrc = "/img/piso-1.png";

            titleName = Localization[locale].spaces_booking.step_1_studio_3;
            titleFloor =
                Localization[locale].spaces_booking.step_1_studio_type_2;
        } else if (space.id === 4) {
            floorText = Localization[locale].spaces_booking.floor1;
            imageSrc = "/img/piso-1.png";

            titleName = Localization[locale].spaces_booking.step_1_studio_4;
            titleFloor =
                Localization[locale].spaces_booking.step_1_studio_type_2;
        }

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>
                <div className="flex flex-col pt-30 overflow-y-auto bg-orange w-full">
                    <div className="flex mb-40 px-16 bg-orange">
                        <div className="flex-1">
                            <p className="font-judge font-bold text-30 text-blue">
                                {titleName}
                                <br />
                                {titleFloor}
                            </p>
                        </div>
                        <Button
                            icon={
                                <IconClose
                                    className={
                                        "w-25 h-25 z-10 transition hover-hover:group-hover:" +
                                        buttonTextColor +
                                        " " +
                                        textColor
                                    }
                                />
                            }
                            backgroundColorOver={buttonBackgroundColor}
                            borderColor={borderColor}
                            onClick={this._onClose}
                            style="w-50"
                        />
                    </div>
                    <div className="flex flex-col px-16 mb-40 bg-orange">
                        <p className="mb-40 text-17 whitespace-pre-line">
                            {space.description}
                        </p>
                        {space.gallery && (
                            <Gallery
                                arrowsBottom={true}
                                padding={null}
                                height={250}
                                data={space.gallery}
                            />
                        )}
                    </div>
                    <div className="bg-blue px-16 pt-40 pb-60">
                        <p className="font-bold text-20 text-orange mb-24">
                            {floorText}
                        </p>
                        <Image
                            url={imageSrc}
                            aspectRatio="aspect-ratio-191/163"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    visible: state.options.isMobileFloorVisible,
    space: getSpaceDetails(state, state.options.floorSlug),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeMobileFloor,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFloor);
